export default __webpack_public_path__ + "static/media/ICON13.e4da74cb.svg";